import { Coords } from 'model';

export class BoundsHelper {

  private readonly  bounds: google.maps.LatLngBounds;

  constructor() {
    this.bounds = new google.maps.LatLngBounds();
  }

  public add(lat: number, lng: number) {
    this.bounds.extend(new google.maps.LatLng(lat, lng));
  }

  public getCenter(): Coords  {
    return { latitude: this.bounds.getCenter().lat(), longitude: this.bounds.getCenter().lng() };
  }

  public getBounds(): google.maps.LatLngBounds {
    return this.bounds;
  }
}
